module.exports = __webpack_public_path__ + "static/8(1)-d2259e1e65618df2a2a2a72139bf8437.jpg";